export default "__VITE_ASSET__xSX_Pqxw__"